module.exports = __webpack_public_path__ + "f57e19a05f0f1719921e6c6703d0396a.png";